import PropTypes from 'prop-types';
import React, {Component} from 'react';
import Box from '../box/box.jsx';
import style from './index.css';
import classNames from 'classnames';
import Draggable from 'react-draggable';


const SVG_DEFAULT_SIZE = {width: 47, height: 47, viewBox: '0 0 150 150'};
/*
 * @desc 这是一个 virtualKeyBoard 的一个模块，也就是一个控制块，里面有控制按钮。目前是四个.
 * @param buttonData
 * @return {*}
 */
const SimpleVirtualBox = props => {
    const keyBox = props.keyBox;
    return (<li
        aria-label="virtual-key"
        aria-pressed={keyBox.isActive ? 'press' : 'release'}
        className={style.virtualBoard_keyBox}
        key={keyBox.id}
        role="button"
        onTouchCancel={keyBox.handleTouchEnd}
        onTouchEnd={keyBox.handleTouchEnd}
        onTouchStart={keyBox.handleTouchStart}
    >
        <keyBox.svgCom
            className={classNames(style.keyBoxInsideSvg, {active: keyBox.isActive})}
            viewBox={keyBox.viewBox || SVG_DEFAULT_SIZE.viewBox}
            // width={keyBox.width || SVG_DEFAULT_SIZE.width}
            // /* eslint-disable */
            // height={keyBox.height || SVG_DEFAULT_SIZE.height}
            /* eslint-enable */
        />
    </li>);
};

class VirtualKeyBoard extends Component {

    constructor (props) {
        super(props);
        this.state = {};
    }

    getVirtualKeys (controllerModal) {
        const children = controllerModal.children;
        return (<ul
            className={style.keysContainer}
            data-layout={children.length}
            key={controllerModal.id}
            role="wheget"
        >
            {
                children.map(keyBox => (
                    <SimpleVirtualBox
                        key={keyBox.id}
                        keyBox={keyBox}
                    />
                ))
            }
        </ul>);
    }

    render () {
        const {visible, virtualKeyData, isFirstDragin} = this.props;
        return (isFirstDragin) ? null : <Box
            aria-hidden={!visible}
            aria-label="virtualBoard-controller"
            className={classNames(style.virtualKeyBoard, {[style.virtualKeyBoardNone]: !visible})}
        >
            {
                virtualKeyData.map(controllerModal => (<Draggable
                    defaultClassName={controllerModal.className}
                    key={controllerModal.id}
                >
                    <div className={style.virtualKeyBoard_modal}>
                        <div className={style.keysContainer_wrap}>
                            { this.getVirtualKeys(controllerModal) }
                        </div>
                    </div>
                </Draggable>))
            }
        </Box>;
    }
}

SimpleVirtualBox.propTypes = {
    keyBox: PropTypes.shape({
        handleTouchEnd: PropTypes.func,
        handleTouchStart: PropTypes.func,
        width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        id: PropTypes.number.isRequired,
        isActive: PropTypes.bool,
        viewBox: PropTypes.string
    })
};

VirtualKeyBoard.propTypes = {
    isFirstDragin: PropTypes.bool,
    virtualKeyData: PropTypes.shape({
        keyBox: PropTypes.object,
        id: PropTypes.number.isRequired,
        children: PropTypes.object,
        className: PropTypes.string
    }),
    visible: PropTypes.bool
};

VirtualKeyBoard.defaultProps = {
    visible: false
};

export default VirtualKeyBoard;
